import { identity } from 'fp-ts/function';
export var all = function all($all) {
  return {
    $all: $all
  };
};
export var any = function any($any) {
  return {
    $any: $any
  };
};
export var not = function not($not) {
  return {
    $not: $not
  };
};
export var hubId = function hubId(id) {
  return {
    field: 'hub_id',
    operator: '$exact',
    string_value: id
  };
};
export var group = function group(id) {
  return {
    group_id: id
  };
};
export var field = identity;